import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    items: [],
  }),
  mutations: {
    [types.UPDATE_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_DATA](state, items) {
      state.items = items;
    },
  },
  actions: {
    /**
     * 获取预取结果
     */
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, route.params, { routeName: route.name }, $params);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/qlist`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));
      result = result && result.data;
      const { status, head = '', items } = result || {};
      if (status === 0 && items) {
        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_DATA, items);
        return result;
      }
      commit(types.UPDATE_HEAD, '');
      commit(types.UPDATE_DATA, {});

      if (status === 302) return result;
      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
